export default __webpack_public_path__ + "static/decorist-6-5a4993f44beef20b253a55de5382c691.webp";